import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.74 4.33a.997.997 0 1 0-1.48 1.34l2.41 2.65c-4.55 2.78-6.5 7.08-6.58 7.27-.11.26-.11.55 0 .81.17.39 4.38 9.59 14.91 9.59h.13c2.19 0 4.37-.49 6.37-1.38l2.77 3.05a.996.996 0 0 0 1.41.07c.41-.37.44-1 .07-1.41zm5.37 10.75c.11-.46.3-.88.55-1.27l5.2 5.72a3.9 3.9 0 0 1-1.84.47c-.85-.03-1.6-.24-2.28-.7a3.96 3.96 0 0 1-1.47-1.86c-.29-.76-.35-1.57-.16-2.36M16 24c-8.13 0-11.99-6.29-12.88-8 .59-1.1 2.49-4.17 5.94-6.16l2.23 2.46c-.53.68-.92 1.47-1.12 2.32a5.95 5.95 0 0 0 .24 3.54c.44 1.13 1.2 2.1 2.2 2.79 1.01.69 2.16 1.06 3.41 1.05a6 6 0 0 0 3.22-.95l1.83 2.02c-1.61.62-3.33.95-5.07.94z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M30.91 15.59C30.74 15.2 26.53 6 16 6c-.89 0-1.85.07-2.75.23-.54.09-.91.61-.82 1.15s.61.91 1.15.82c.8-.13 1.62-.18 2.42-.2 8.13 0 11.99 6.29 12.88 8-.43.8-1.54 2.67-3.48 4.4-.41.37-.45 1-.08 1.41.2.22.47.33.75.33.24 0 .48-.08.67-.25 2.85-2.55 4.12-5.36 4.17-5.48.11-.26.11-.55 0-.81z"
    />
    <path
      fill="currentColor"
      d="M19.98 15.61c-.08-.85-.44-1.67-1.02-2.31l.01.01a4.04 4.04 0 0 0-2.21-1.23 1 1 0 0 1-.8-1.17c.1-.55.62-.91 1.17-.8 1.27.24 2.44.9 3.31 1.85s1.41 2.18 1.53 3.47a.99.99 0 0 1-.9 1.09h-.09a1 1 0 0 1-1-.91"
    />
  </svg>
);
const SvgIconEyeSlash = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconEyeSlash);
export default Memo;
